// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnalysisBoard_wrapper__2DT7u"};